/**
 * Lemon Squeezy — redirección al checkout de suscripción.
 *
 * Invitados sin sesión: se envía a registro con retorno a /checkout para ligar user_id/custom_data.
 * Con token (sesión Aurora): se reutiliza /checkout para rellenar contexto desde AuthContext.
 *
 * custom_data (webhooks): https://docs.lemonsqueezy.com/help/checkout/passing-custom-data
 */
import { isUsClinicalHost } from "./usClinicalHost";

const DEFAULT_LEMON_CHECKOUT_URL =
  "https://aurorageriatrica.lemonsqueezy.com/checkout/buy/cbe773cc-477b-436e-84c8-1424e4b8f490?discount=0";

function baseCheckoutUrl() {
  const isUsHost = isUsClinicalHost();
  const env = typeof process !== "undefined" && process.env ? process.env : {};
  const envUrl =
    (isUsHost ? env.REACT_APP_LEMON_CHECKOUT_URL_US : env.REACT_APP_LEMON_CHECKOUT_URL_LATAM) ||
    env.REACT_APP_LEMON_CHECKOUT_URL ||
    "";
  const candidate = (envUrl || "").trim();

  if (isUsHost && !candidate) {
    console.warn(
      "[checkout] Host USA detectado sin REACT_APP_LEMON_CHECKOUT_URL_US. Usando checkout por defecto."
    );
  }
  if (!isUsHost && !candidate) {
    console.warn(
      "[checkout] Host LATAM detectado sin REACT_APP_LEMON_CHECKOUT_URL_LATAM. Usando checkout por defecto."
    );
  }

  const legacyCandidate =
    typeof process !== "undefined" && process.env
      ? process.env.REACT_APP_LEMON_CHECKOUT_URL
      : "";
  const finalCandidate = candidate || (legacyCandidate || "").trim();

  if (!finalCandidate) {
    return DEFAULT_LEMON_CHECKOUT_URL;
  }

  try {
    const parsed = new URL(finalCandidate);
    const isLemonHost = parsed.hostname.toLowerCase().includes("lemonsqueezy.com");
    if (!isLemonHost) {
      console.error(
        "[checkout] REACT_APP_LEMON_CHECKOUT_URL no apunta a Lemon Squeezy. Usando DEFAULT_LEMON_CHECKOUT_URL.",
        finalCandidate
      );
      return DEFAULT_LEMON_CHECKOUT_URL;
    }
    return parsed.toString();
  } catch {
    console.error(
      "[checkout] REACT_APP_LEMON_CHECKOUT_URL inválida. Usando DEFAULT_LEMON_CHECKOUT_URL.",
      finalCandidate
    );
    return DEFAULT_LEMON_CHECKOUT_URL;
  }
}

export function getPublicCheckoutUrl() {
  return baseCheckoutUrl();
}

/**
 * @param {object} [context] - Usuario autenticado: id + email para custom_data en Lemon.
 * @param {string} [context.userId]
 * @param {string} [context.email]
 * @param {string} [context.name]
 */
export function startSubscriptionCheckout(context) {
  const base = baseCheckoutUrl();
  const userId =
    (context &&
      (context.userId || context.user_id || "").trim &&
      (context.userId || context.user_id).trim()) ||
    "";
  const email =
    (context && context.email && context.email.trim && context.email.trim()) ||
    "";
  const name =
    (context && context.name && context.name.trim && context.name.trim()) || "";

  if (!base) {
    console.error("[checkout] No se encontró URL de checkout de Lemon.");
    return;
  }

  let url;
  try {
    url = new URL(base);
  } catch {
    console.error(
      "[checkout] URL de checkout inválida al redirigir. Intentando fallback directo.",
      base
    );
    window.location.href = base;
    return;
  }

  if (email) {
    url.searchParams.set("checkout[email]", email);
  }
  if (name) {
    url.searchParams.set("checkout[name]", name);
  }
  if (userId) {
    url.searchParams.set("checkout[custom][user_id]", userId);
    url.searchParams.set("checkout[custom][aurora_user_id]", userId);
  }

  window.location.href = url.toString();
}
